import peopleIdentity from 'owa-service/lib/factory/peopleIdentity';
/**
 * Maps the recipient well from the rule edit page to PeopleIdentity type
 * @return the PeopleIdentity list with the corresponding recipients as items
 */
export default function mapRecipientWellWithFindControlViewStateToPeopleIdentity(recipientWell) {
    // map conditional clauses
    var peopleIdentities = [];
    for (var _i = 0, _a = recipientWell.recipients; _i < _a.length; _i++) {
        var recipient = _a[_i];
        var mailbox = recipient.persona.EmailAddress;
        var identity = peopleIdentity({
            DisplayName: mailbox.Name,
            SmtpAddress: mailbox.EmailAddress,
            RoutingType: mailbox.RoutingType,
        });
        peopleIdentities.push(identity);
    }
    return peopleIdentities.length > 0 ? peopleIdentities : null;
}
//# sourceMappingURL=mapReadWriteRecipientWellViewStateToPeopleIdentity.js.map